import React, { useEffect, useState } from "react";
import styles from "./MyOrders.module.scss";
import Table from "../../../../common/Table/Table";
import Tooltip from "../../../../common/Tooltip/Tooltip";
import CopyBtn from "../../../../common/CopyBtn/CopyBtn";
import Pagination from "../../../../common/Pagination/Pagination";
import Button from "../../../../common/Button/Button";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import sampleImg from "../../../../../assets/images/dummy-profile.png";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice, toFix } from "../../../../../utils/utils";
import CancelOrder from "../../../../common/Modals/CancelOrder/CancelOrder";
import { cancelOrderAction } from "../../../../../features/user/userSlice";
import { format } from "date-fns";
import PtpOrderDetails from "../../../../common/Modals/PtpOrderDetails/PtpOrderDetails";

const MyOrders = ({
  page,
  setPage,
  size,
  handleSorting,
  getUserBuySellOrders,
  orderType, // Receive the orderType prop
}) => {
  const dispatch = useDispatch();
  const userOrders = useSelector((state) => state.users.userP2PTxns);
  const [loading, setLoading] = useState(true);
  const [cancelModal, setCancelModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  const baseURL = userOrders?.profileUrl;
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const fields = [
    { label: "Order ID" },
    { label: "User" },
    { label: "Asset" },
    { label: "Quantity", sort: true },
    { label: "Order Type" },
    { label: "Price", sort: true },
    { label: "Created At" },
    ...(orderType !== "COMPLETED" ? [] : [{ label: "Matched At" }]), // Conditional field
    { label: "Status" },
    ...(orderType === "COMPLETED" ? [] : [{ label: "Action" }]), // Conditional field
  ];

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1400);
  }, []);

  const handleCancelSubmit = async () => {
    try {
      let dataObj = {
        orderId: selectedOrder,
      };
      const response = await dispatch(cancelOrderAction(dataObj));
      if (response.status === 200) {
        setCancelModal(false);
        getUserBuySellOrders();
      }
    } catch (error) { }
  };

  return (
    <>
      <Table
        noRecordContent={"No records were found."}
        noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        loading={loading}
        fields={fields}
        onClick={(col) => handleSorting(col)}
        className={styles.table}
      >
        {userOrders?.totalItems > 0 &&
          userOrders?.rows?.map((item) => (
            <tr key={item.order_uid}>
              <td>
                <Tooltip
                  icon={<span>{"..." + item.order_uid.slice(-5)}</span>}
                  content={
                    <>
                      <CopyBtn text={item.order_uid} /> {item.order_uid}
                    </>
                  }
                  className={styles.orderId}
                />
              </td>
              <td className={styles.user_details}>
                <img
                  alt="user"
                  src={
                    item?.user?.profile_pic !== null
                      ? baseURL + item?.user?.profile_pic
                      : sampleImg
                  }
                />
                {item?.user?.username?.length > 7
                  ? item?.user?.username?.slice(0, 8) + "..."
                  : item?.user?.username}
              </td>

              <td>{item?.master_tokens_configuration?.name}</td>
              <td>
                {Number(
                  toFix(
                    Number(item?.quantity),
                    decimalLimit[item?.master_tokens_configuration?.name]
                  )
                )}
              </td>
              <td>{item?.order_type}</td>
              <td>{formatPrice(Number(item?.price))}</td>
              <td>
                {item?.created_at &&
                  format(new Date(item?.created_at), "dd/MM/yy,hh:mm a")}
              </td>
              {orderType === "COMPLETED" && (
                <td>
                  {item?.updated_at &&
                    format(new Date(item.updated_at), "dd/MM/yy, hh:mm a")}
                </td>
              )}
              <td>{item?.order_status}</td>
              {orderType !== "COMPLETED" && (
                <td>
                  {item?.order_status === "PENDING" ? (
                    <Button
                      text="Cancel"
                      onClick={() => {
                        setSelectedOrder(item?.order_uid);
                        setCancelModal(true);
                      }}
                    />
                  ) : (
                    <>-</>
                    // <Button
                    //   text="Details"
                    //   onClick={() => {
                    //     setSelectedOrder(item?.order_uid);
                    //     // setCancelModal(true);
                    //   }}
                    // />
                  )}
                </td>
              )}
            </tr>
          ))}
      </Table>
      {userOrders?.totalItems > size && (
        <Commonpagination
          currentPage={page}
          className={styles.pagination}
          pageSize={size}
          totalPages={userOrders.totalPages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
      <CancelOrder
        show={cancelModal}
        handleClose={() => setCancelModal(false)}
        handleCancelSubmit={handleCancelSubmit}
      />
      <PtpOrderDetails />
    </>
  );
};

export default MyOrders;
